import { ReactNode } from 'react';
import { TfiHome } from 'react-icons/tfi';
import { LuCalendarClock, LuDollarSign } from 'react-icons/lu';
import { CiFolderOn } from 'react-icons/ci';
import { TbSubtask } from 'react-icons/tb';
import { IoSettingsOutline } from 'react-icons/io5';
import { HiOutlineDocumentDownload } from 'react-icons/hi';
import { BsExclamationOctagon } from 'react-icons/bs';
import appRoutes from 'config/appRoutes';
import { PermissionKey } from 'config/permissions';
import { FiAtSign } from 'react-icons/fi';

interface MenuItemBaseType {
  label: string;
  permission?: PermissionKey;
  role?: string;
  needsSuperUser?: boolean;
  type?: 'regular_user' | 'contact' | 'freelancer';
}

export interface MenuItemBaseLinkType extends MenuItemBaseType {
  path: string;
}

export interface MenuItemLinkType extends MenuItemBaseLinkType {
  icon: ReactNode;
  showBadgeWhenCollapsed?: boolean;
  externalUrl?: string;
}

export interface MenuItemParentType extends MenuItemBaseType {
  icon: ReactNode;
  submenu: MenuItemBaseLinkType[];
  key: string;
}

export type MenuItemType = MenuItemLinkType | MenuItemParentType;

export const regularUserConfig: MenuItemType[] = [
  {
    label: 'Dashboard',
    path: appRoutes.DASHBOARD,
    icon: <TfiHome />,
    permission: 'DASHBOARD_READ',
  },
  {
    label: 'Mentions',
    path: appRoutes.INBOX,
    icon: <FiAtSign strokeWidth={1} />,
    permission: 'COMMENTS_READ',
    showBadgeWhenCollapsed: true,
  },
  {
    label: 'Pending',
    path: appRoutes.PENDING_REPLIES,
    icon: <BsExclamationOctagon />,
    permission: 'COMMENTS_READ',
    showBadgeWhenCollapsed: true,
  },
  {
    label: 'Tasks',
    path: appRoutes.TASKS,
    icon: <TbSubtask strokeWidth="1" />,
    permission: 'TASKS_READ',
    showBadgeWhenCollapsed: true,
  },

  {
    label: 'Plans',
    path: appRoutes.PROJECTS,
    icon: <CiFolderOn />,
    permission: 'PROJECTS_READ',
    type: 'regular_user',
  },
  {
    label: 'Timelog',
    path: appRoutes.TIME_LOG_REPORT,
    icon: <LuCalendarClock strokeWidth="1" />,
    permission: 'TIMELOG_READ',
  },
  {
    label: 'Requests',
    path: appRoutes.REQUESTS,
    icon: <HiOutlineDocumentDownload strokeWidth="1" />,
    permission: 'REQUEST_READ',
    showBadgeWhenCollapsed: true,
  },
  {
    label: 'Estimator',
    path: 'estimator',
    icon: <LuDollarSign strokeWidth="1" />,
    externalUrl: 'https://estimator.lionshare.app/',
  },
  {
    key: 'admin',
    label: 'Admin',
    icon: <IoSettingsOutline />,
    type: 'regular_user',
    submenu: [
      {
        label: 'Internal users',
        path: appRoutes.INTERNAL_USERS,
        permission: 'CONTACTS_READ',
      },
      {
        label: 'Contacts',
        path: appRoutes.CONTACTS_LIST,
        permission: 'CONTACTS_READ',
      },
      {
        label: 'Users report',
        path: appRoutes.REPORT_USER_PERFORMANCE,
        permission: 'PROJECTS_READ',
      },
      {
        label: 'Groups',
        path: appRoutes.GROUPS,
        permission: 'GROUPS_READ',
        needsSuperUser: true,
      },
      {
        label: 'API tokens',
        path: appRoutes.API_TOKENS,
      },
    ],
  },
];

const allRoutes: MenuItemBaseLinkType[] = [];

regularUserConfig.forEach((el) => {
  if ('submenu' in el) {
    el.submenu.forEach((sub) => {
      allRoutes.push(sub);
    });
  } else {
    allRoutes.push(el);
  }
});

export const getRouteConfig = () => {
  return regularUserConfig;
};

export const getAllRoutes = () => {
  return allRoutes;
};
